import { t1 } from 'translate';

export const yesNoOptions = () => [
  { value: 1, label: t1('yes') },
  { value: 0, label: t1('no') },
];
